import { render, staticRenderFns } from "./StudentsPage.vue?vue&type=template&id=fe9fd1a0"
import script from "./StudentsPage.vue?vue&type=script&lang=js"
export * from "./StudentsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports